import * as _ from 'lodash';
import { ImsObject } from './ims_object';
import { CustomIMSConfigResource } from 'app/shared/resources';

const IMS_TYPE = 'config';

export class UserGeneratedConfig extends ImsObject {
    public type: string;

    constructor(resource = new CustomIMSConfigResource()) {
        super(IMS_TYPE, resource);
    }

    get jsonConfig(): any {
        return this.resource.json_config;
    }

    clone() {
        const resourceClone = _.clone(this.resource);
        return new UserGeneratedConfig(resourceClone);
    }
}
